"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLoader = exports.StyledContainer = exports.StyledText = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var fos_ui_1 = require("@ntet/fos-ui");
var StyledText = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  font-size: 1.8rem;\n  margin-top: 7rem;\n  font-family: ", ";\n  color: ", ";\n"], ["\n  font-size: 1.8rem;\n  margin-top: 7rem;\n  font-family: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[700];
});
exports.StyledText = StyledText;
var StyledContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  height: 100%;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  height: 100%;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
exports.StyledContainer = StyledContainer;
var StyledLoader = function () { return react_1.default.createElement(fos_ui_1.Loader, null); };
exports.StyledLoader = StyledLoader;
var templateObject_1, templateObject_2;
